import { InjectionToken } from '@angular/core';

export const DIALOG_PROPERTIES = new InjectionToken<any>('DIALOG_PROPERTIES');
